import React from 'react'
import { Bike } from 'lucide-react'

interface BikePathToggleControlProps {
  showBikePaths: boolean
  onToggle: () => void
  className?: string
}

export function BikePathToggleControl({ 
  showBikePaths, 
  onToggle, 
  className = '' 
}: BikePathToggleControlProps) {
  return (
    <button
      onClick={onToggle}
      className={`${className} mapboxgl-ctrl-icon`}
      aria-label={showBikePaths ? 'Hide bike paths' : 'Show bike paths'}
      title={showBikePaths ? 'Hide bike paths' : 'Show bike paths'}
      style={{
        width: '29px',
        height: '29px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'transparent'
      }}
    >
      <Bike 
        className="w-4 h-4"
        style={{ 
          strokeWidth: 2
        }}
      />
    </button>
  )
}